import React from 'react';

import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { AbsenceChange, ActionTypeEnum, LogsItem } from '../../types/interfaces';

interface AbsencesExpansionProps {
  rowData: LogsItem;
  addedItems: AbsenceChange[];
  deletedItems: AbsenceChange[];
  updatedItems: Array<{
    id: number;
    old: AbsenceChange;
    new: AbsenceChange;
  }>;
  actionLabel: string;
}

export const AbsencesExpansion: React.FC<AbsencesExpansionProps> = ({
  rowData,
  addedItems,
  deletedItems,
  updatedItems,
  actionLabel
}) => {
  return (
    <div >
      {rowData.actionType === ActionTypeEnum.CREATEABSENCE &&
        addedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} отсутствия</h5>
          <DataTable
            dataKey="id"
            value={addedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="from"
              field="from"
              header="От"
              body={(row: AbsenceChange) =>
                moment(row.from).format('DD.MM.YYYY HH:mm')
              }
            />
            <Column
              columnKey="to"
              field="to"
              header="До"
              body={(row: AbsenceChange) =>
                moment(row.to).format('DD.MM.YYYY HH:mm')
              }
            />
            <Column
              columnKey="absence.label"
              field="absence.label"
              header="Тип отсутствия"
            />
          </DataTable>
        </div>
      )}

      {rowData.actionType === ActionTypeEnum.DELETEABSENCE &&
        deletedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} отсутствия</h5>
          <DataTable
            dataKey="id"
            value={deletedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="from"
              field="from"
              header="От"
              body={(row: AbsenceChange) =>
                moment(row.from).format('DD.MM.YYYY HH:mm')
              }
            />
            <Column
              columnKey="to"
              field="to"
              header="До"
              body={(row: AbsenceChange) =>
                moment(row.to).format('DD.MM.YYYY HH:mm')
              }
            />
            <Column
              columnKey="absence.label"
              field="absence.label"
              header="Тип отсутствия"
            />
          </DataTable>
        </div>
      )}

      {rowData.actionType === ActionTypeEnum.UPDATEABSENCE &&
        updatedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} отсутствия</h5>
          <DataTable
            dataKey="id"
            value={updatedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="from"
              header="От"
              body={(row: {
                  id: number;
                  old: AbsenceChange;
                  new: AbsenceChange;
                }) => {
                const oldFrom = row.old.from
                  ? moment(row.old.from).format('DD.MM.YYYY HH:mm')
                  : '';
                const newFrom = row.new.from
                  ? moment(row.new.from).format('DD.MM.YYYY HH:mm')
                  : '';
                const changed = newFrom && oldFrom && oldFrom !== newFrom;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldFrom}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newFrom}
                      </>
                    ) : (
                      newFrom || oldFrom || ''
                    )}
                  </span>
                );
              }}
            />
            <Column
              columnKey="to"
              header="До"
              body={(row: {
                  id: number;
                  old: AbsenceChange;
                  new: AbsenceChange;
                }) => {
                const oldTo = row.old.to
                  ? moment(row.old.to).format('DD.MM.YYYY HH:mm')
                  : '';
                const newTo = row.new.to
                  ? moment(row.new.to).format('DD.MM.YYYY HH:mm')
                  : '';
                const changed = newTo && oldTo && oldTo !== newTo;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldTo}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newTo}
                      </>
                    ) : (
                      newTo || oldTo || ''
                    )}
                  </span>
                );
              }}
            />
            <Column
              columnKey="absence.label"
              header="Тип отсутствия"
              body={(row: {
                  id: number;
                  old: AbsenceChange;
                  new: AbsenceChange;
                }) => {
                const oldValue = row.old.absence?.label || '';
                const newValue = row.new.absence?.label || '';
                const changed =
                    newValue && oldValue && oldValue !== newValue;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldValue}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newValue}
                      </>
                    ) : (
                      newValue || oldValue || ''
                    )}
                  </span>
                );
              }}
            />
          </DataTable>
        </div>
      )}
    </div>
  );
};
